<template>
  <chart-container @onPNGDownload="downloadGraphs(titleChart, 'png', downloadId)" :titleChart="titleChart" @onCSVDownload="downloadGraphs(titleChart, 'csv', downloadId)" @onPDFDownload="downloadGraphs(titleChart, 'pdf', downloadId)" :isZoomEnabled="false" :downloadId="downloadId" :specificSiteId="specificSiteId" :downloadShow="listTop5.length > 0">
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs v-model="tabQueriesTop5">
        <b-tab v-for="(tabName, index) in tabListTopFiveQueries" :key="index" :title="tabName" />
      </b-tabs>
    </span>
    <table class="table table-hover table-borderless" slot="body">
      <tbody>
        <div v-if="listTop5.length > 0">
          <tr v-for="(item, index) in listTop5" :key="index">
            <td style="width: 5px" class="top-time-activity-text">
              <span class="pdt-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
                  <g fill="#7F69D5" clip-path="url(#clip0)">
                    <path
                      :fill="primaryColor"
                      d="M10.383 8.246c.678-1.136.919-2.48.678-3.78-.24-1.3-.947-2.469-1.986-3.286C8.035.362 6.734-.05 5.413.023c-1.32.073-2.57.623-3.514 1.55C.955 2.499.381 3.738.284 5.057.187 6.376.574 7.685 1.37 8.74c.798 1.054 1.953 1.782 3.249 2.048 1.295.265 2.643.049 3.792-.608l2.428 2.434c.259.259.61.404.976.404s.717-.145.975-.404c.26-.259.404-.61.404-.976s-.145-.717-.404-.975l-2.408-2.417zm-.967-.967c-.42.848-1.115 1.528-1.972 1.928-.883.409-1.883.493-2.822.237-.94-.257-1.758-.837-2.311-1.638-.553-.802-.805-1.773-.712-2.742.094-.97.527-1.875 1.223-2.555.696-.681 1.61-1.094 2.582-1.166.97-.072 1.936.202 2.725.772.789.571 1.35 1.402 1.586 2.347.236.945.13 1.943-.3 2.817z"
                    />
                    <path :fill="primaryColor" d="M7.312 3.509L5.01 5.812l-.648-.647c-.166-.167-.391-.26-.626-.26s-.46.093-.627.259c-.166.166-.26.391-.26.626s.093.46.26.627l.68.68.179.18.83.828c.053.056.126.088.202.09.077.003.152-.025.208-.076l.839-.843.211-.211L8.564 4.76c.161-.167.25-.39.248-.622-.003-.232-.096-.454-.26-.618-.164-.164-.386-.257-.617-.26-.232-.002-.456.087-.623.248z" />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <path fill="#fff" d="M0 0H13V13H0z" transform="translate(.23 .019)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </td>
            <td style="width: 5px" class="top-time-activity-text-padding-right">
              <span class="top-time-activity-text-number">{{ index + 1 }}</span>
            </td>
            <td style="text-align: left" class="top-time-activity-text">
              {{ item.label }}
            </td>
            <td style="text-align: right" class="top-time-activity-text">
              <span>{{ item.value }}</span>
            </td>
          </tr>
        </div>

        <div v-else class="align-center p-60">
          <div class="card-text-title no-data" v-if="dataLoaded">
            No Data In
          </div>
          <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
        </div>
      </tbody>
    </table>
  </chart-container>
</template>

<script>
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import { downloadCSV, getSiteID } from "../../services/visualization/data-management";
import moment from "moment";
import ChartContainer from "./chart-container.vue";
import * as srv from "@/services/visualization/data-management";
import _ from "lodash";

export default {
  components: { ChartContainer },
  props: {
    queriesRaw: { type: [Object, Array], default: () => [] },
    downloadId: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => [] },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    filterTriggered: { type: Boolean, default: false },
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      primaryColor: "#000",
      containerId: "top-five-queries-data-management",
      todayDate: "",
      tDateShow: true,
      tabQueriesTop5: 0,
      getSiteID,
      listTop5: [],
      tabListTopFiveQueries: ["Frequently Occurring", "Open Queries"]
    };
  },
  watch: {
    queriesRaw: function(newValue) {
      this.listTop5 = srv.getQueriesTop5(newValue, this.countrySelected, this.sitesSelected, this.tabQueriesTop5);
    },
    listTop5: function(newValue) {
      this.listTop5 = newValue;
      const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
      this.primaryColor = primaryColor || "#00C3B3";
    },
    filterTriggered: function() {
      this.listTop5 = srv.getQueriesTop5(this.queriesRaw, this.countrySelected, this.sitesSelected, this.tabQueriesTop5);
    },
    tabQueriesTop5: function(newValue) {
      this.listTop5 = srv.getQueriesTop5(this.queriesRaw, this.countrySelected, this.sitesSelected, newValue);
    }
  },
  methods: {
    downloadGraphs(titleChart, type, downloadId) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        switch (type) {
          case "csv":
            const csvHeaders = this.generateCsvHeaders(this.tabQueriesTop5);
            this.tDateShow = true;
            const csvContent = [];

            this.listTop5.map(item => csvContent.push([item.label, item.value]));
            downloadCSV(titleChart, csvHeaders, csvContent, this.specificSiteId);
            break;
          case "pdf":
            let filename = titleChart + "_" + this.todayDate + ".pdf";
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".pdf";
            }
            let container = document.querySelector("#" + downloadId);
            this.tDateShow = true;
            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(canvas => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jspdf("p", "mm", "a4");
              const imgProps = pdf.getImageProperties(imgData);
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

              pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
              pdf.save(filename);
            });
            break;
          case "png":
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".png";
            }
            this.tDateShow = true;
            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(function(canvas) {
              const link = document.createElement("a");
              document.body.appendChild(link);
              link.download = filename;
              link.href = canvas.toDataURL("image/png");
              link.target = "_blank";
              link.click();
            });
            break;
          default:
            break;
        }
      }, 1);
    },
    generateCsvHeaders(tabQueriesTop5) {
      const headers = ["Activity Name"];
      switch (tabQueriesTop5) {
        case 0:
          headers.push("Frequently Occurring");
          break;
        case 1:
          headers.push("Open Queries");
          break;
        default:
          break;
      }

      return headers;
    }
  },
  mounted() {
    const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
    this.primaryColor = primaryColor || "#00C3B3";
  }
};
</script>
<style lang="scss" scoped>
.pdt-5 {
  margin-right: 2.2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 23px;
}

.full-width-100 {
  width: 100%;
}
</style>
